import type { CustomCellRenameSelection } from '@cli-types/core-engine/snapshots.js'

export function buildCustomCellRenameSelection(
  schemaName: string,
  pagesDir: string,
  before: string,
  after: string
): CustomCellRenameSelection {
  return {
    before,
    after,
    oldPath: `${pagesDir}/${schemaName}/cells/${before}.tsx`,
    newPath: `${pagesDir}/${schemaName}/cells/${after}.tsx`,
    columnsPath: `${pagesDir}/${schemaName}/columns.tsx`
  }
}
